import React from "react";
import { connect } from "react-redux";
import { _validateEmail, _handleChange, _clearEmail } from "./actions";
import Session from "../../utility/session";
import { emailStatus } from "../../utility/enums";
import { ValidationSummary } from "../../utility/ValidationSummary";
//import SingleVerificationList from "../../components/EmailVerification/VerificationJobsList/SingleVerificationList";
import { switchTab } from "../EmailValidation/actions";
import {
  singleEmaildValidators,
  updateValidators,
  initValidations,
} from "../../utility/validations";
const mapStateToProps = (state) => ({
  validateEmail: state.validateEmail,
  username: state.loginInfo.username,
});
class SingleEmailForm extends React.Component {
  constructor(props) {
    super(props);
    // moving email to local state
    this.state = { showErrorSummary: false, email: '' };
    this.validators = singleEmaildValidators;
    initValidations(this.validators);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearEmail = this.clearEmail.bind(this);
  }

  handleChange(event) {
    const email = event.target.value.trim();
    // clearing validation result of previous email
    this.props.dispatch(_clearEmail());

    this.setState({showErrorSummary: false, email });
    updateValidators(this.validators, event.target.name, email);
  }

  clearEmail() {
    if(this.props.validateEmail.showLoader) return;
    
    // clearing validation result of previous email
    this.props.dispatch(_clearEmail());

    this.setState({ showErrorSummary: false, email: '' });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ showErrorSummary: true });

    if (this.validators.errorSummary.length == 0) {
      this.props.dispatch(
        _validateEmail(
          this.state.email,
          0,
          Session.getItem("current_username")
        )
      );
      this.props.dispatch(switchTab("single"));
    }
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        {this.state.showErrorSummary ? (
          <ValidationSummary errorMsg={this.validators.errorSummary} />
        ) : null}
        <div className="form-group clearfix">
          <div className="col-sm-12 col-md-12" style={{ paddingLeft: 0 }}>
            <input
              disabled={this.props.validateEmail && this.props.validateEmail.showLoader}
              name="email"
              id="email"
              placeholder="email@example.com"
              className="form-control has-feedback-left"
              type="text"
              value={this.state.email}
              onChange={this.handleChange}
            />
            {
            this.state.email &&
            <button
              style={this.props.validateEmail.showLoader ? {cursor:"not-allowed"} :{cursor:"pointer"}}
              className="close-icon"
              type="reset"
              value="reset"
              onClick={this.clearEmail}
            /> || ""
            }

            {/* <input
              type="text"
              name="focus"
              className="search-box"
              placeholder="Enter search term"
            />
            <button className="close-icon" type="reset" /> */}

            <span />
            <span
              className="fa fa-envelope form-control-feedback left"
              aria-hidden="true"
            />
            <div className="notification" />
            <div className="buttonSec">
              {
              this.props.validateEmail && this.props.validateEmail.showLoader ? 
              <div style={{textAlign:"center"}}>
                <i style={{textAlign:"center"}} class="fa fa-spinner fa-spin fa-2x"></i>
              </div> :
              <button
                id="verify"
                className="btn btn-primary"
                disabled={this.state.email.length === 0}
              >
                <span>
                  <i id="verify_icon" className="fa fa-check-square" /> Verify
                  Email Address
                </span>
              </button>
              }
              <div
                className="notification"
                style={{ display: "inline-block", marginLeft: 30 + "px", textTransform:"capitalize" }}
              >
                <i
                  className={
                    this.props.validateEmail.result == emailStatus.VALID
                      ? "fa fa-check-circle text-green"
                      : this.props.validateEmail.result == emailStatus.INVALID
                      ? "fa fa-close text-red"
                      : this.props.validateEmail.status == emailStatus.UNKNOWN
                      ? "fa fa-question-circle"
                      : ""
                  }
                  aria-hidden="true"
                />
                {this.props.validateEmail.result ? 
                ([emailStatus.VALID, 
                  emailStatus.INVALID, 
                  emailStatus.UNKNOWN].includes(this.props.validateEmail.result)
                  ? " " + this.props.validateEmail.result + "  email" : 
                  // this.props.validateEmail.result
                  ""
                ) : ""}
                {/* <i class="fa fa-check-circle text-green" aria-hidden="true"></i> */}
              </div>
            </div>
          </div>
          <div className="clearfix" />
        </div>
      </form>
    );
  }
}

export default connect(mapStateToProps)(SingleEmailForm);



// WEBPACK FOOTER //
// ./src/Containers/SingleEmailValidation/index.js